import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _assertThisInitialized from "/app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _inherits from "/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/app/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import _classPrivateFieldInitSpec from "/app/node_modules/@babel/runtime/helpers/esm/classPrivateFieldInitSpec.js";
import _classPrivateFieldGet from "/app/node_modules/@babel/runtime/helpers/esm/classPrivateFieldGet.js";
import _classPrivateFieldSet from "/app/node_modules/@babel/runtime/helpers/esm/classPrivateFieldSet.js";
import _slicedToArray from "/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.weak-map.js";
import "core-js/modules/web.dom-collections.iterator.js";
// Copyright 2017-2022 @polkadot/types-codec authors & contributors
// SPDX-License-Identifier: Apache-2.0
import { assert, compactFromU8aLim, isU8a, logger, u8aToU8a } from '@polkadot/util';
import { AbstractArray } from "../abstract/AbstractArray.js";
import { decodeU8aVec, typeToConstructor } from "../utils/index.js";
var MAX_LENGTH = 64 * 1024;
var l = logger('Vec');

function noopSetDefinition(d) {
  return d;
}

function decodeVecLength(value) {
  if (Array.isArray(value)) {
    return [value, value.length, 0];
  }

  var u8a = u8aToU8a(value);

  var _compactFromU8aLim = compactFromU8aLim(u8a),
      _compactFromU8aLim2 = _slicedToArray(_compactFromU8aLim, 2),
      startAt = _compactFromU8aLim2[0],
      length = _compactFromU8aLim2[1];

  assert(length <= MAX_LENGTH, function () {
    return "Vec length ".concat(length.toString(), " exceeds ").concat(MAX_LENGTH);
  });
  return [u8a, length, startAt];
}

export function decodeVec(registry, result, value, startAt, Type) {
  if (Array.isArray(value)) {
    var count = result.length;

    for (var i = 0; i < count; i++) {
      var entry = value[i];

      try {
        result[i] = entry instanceof Type ? entry : new Type(registry, entry);
      } catch (error) {
        l.error("Unable to decode on index ".concat(i), error.message);
        throw error;
      }
    }

    return [0, 0];
  }

  return decodeU8aVec(registry, result, u8aToU8a(value), startAt, Type);
}
/**
 * @name Vec
 * @description
 * This manages codec arrays. Internally it keeps track of the length (as decoded) and allows
 * construction with the passed `Type` in the constructor. It is an extension to Array, providing
 * specific encoding/decoding on top of the base type.
 */

var _Type = /*#__PURE__*/new WeakMap();

export var Vec = /*#__PURE__*/function (_AbstractArray) {
  _inherits(Vec, _AbstractArray);

  var _super = _createSuper(Vec);

  function Vec(registry, Type) {
    var _this;

    var value = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

    var _ref = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
        definition = _ref.definition,
        _ref$setDefinition = _ref.setDefinition,
        setDefinition = _ref$setDefinition === void 0 ? noopSetDefinition : _ref$setDefinition;

    _classCallCheck(this, Vec);

    var _decodeVecLength = decodeVecLength(value),
        _decodeVecLength2 = _slicedToArray(_decodeVecLength, 3),
        decodeFrom = _decodeVecLength2[0],
        length = _decodeVecLength2[1],
        startAt = _decodeVecLength2[2];

    _this = _super.call(this, registry, length);

    _classPrivateFieldInitSpec(_assertThisInitialized(_this), _Type, {
      writable: true,
      value: void 0
    });

    _classPrivateFieldSet(_assertThisInitialized(_this), _Type, definition || setDefinition(typeToConstructor(registry, Type)));

    var _ref2 = isU8a(decodeFrom) ? decodeU8aVec(registry, _assertThisInitialized(_this), decodeFrom, startAt, _classPrivateFieldGet(_assertThisInitialized(_this), _Type)) : decodeVec(registry, _assertThisInitialized(_this), decodeFrom, startAt, _classPrivateFieldGet(_assertThisInitialized(_this), _Type)),
        _ref3 = _slicedToArray(_ref2, 1),
        decodedLength = _ref3[0];

    _this.initialU8aLength = decodedLength;
    return _this;
  }

  _createClass(Vec, [{
    key: "Type",
    get:
    /**
     * @description The type for the items
     */
    function get() {
      return _classPrivateFieldGet(this, _Type).name;
    }
    /**
     * @description Finds the index of the value in the array
     */

  }, {
    key: "indexOf",
    value: function indexOf(_other) {
      // convert type first, this removes overhead from the eq
      var other = _other instanceof _classPrivateFieldGet(this, _Type) ? _other : new (_classPrivateFieldGet(this, _Type))(this.registry, _other);

      for (var i = 0; i < this.length; i++) {
        if (other.eq(this[i])) {
          return i;
        }
      }

      return -1;
    }
    /**
     * @description Returns the base runtime type name for this instance
     */

  }, {
    key: "toRawType",
    value: function toRawType() {
      return "Vec<".concat(this.registry.getClassName(_classPrivateFieldGet(this, _Type)) || new (_classPrivateFieldGet(this, _Type))(this.registry).toRawType(), ">");
    }
  }], [{
    key: "with",
    value: function _with(Type) {
      var definition; // eslint-disable-next-line no-return-assign

      var setDefinition = function setDefinition(d) {
        return definition = d;
      };

      return /*#__PURE__*/function (_Vec) {
        _inherits(_class, _Vec);

        var _super2 = _createSuper(_class);

        function _class(registry, value) {
          _classCallCheck(this, _class);

          return _super2.call(this, registry, Type, value, {
            definition: definition,
            setDefinition: setDefinition
          });
        }

        return _createClass(_class);
      }(Vec);
    }
  }]);

  return Vec;
}(AbstractArray);